// src/store/designSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface DesignState {
  designData: any | null;
}

const initialState: DesignState = {
  designData: null,
};

export const designSlice = createSlice({
  name: "design",
  initialState,
  reducers: {
    setDesignData: (state, action: PayloadAction<any>) => {
      state.designData = action.payload;
    },
    clearDesignData: (state) => {
      state.designData = null
    }
  },
});

export const { setDesignData } = designSlice.actions;
export default designSlice.reducer;
